<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1"><a id="page_3"><strong>We Are the Forgotten</strong></a></h1><a id="page_3">
<p class="poem-linet">We are the old, the unremembered dead.</p>
<p class="poem-line">Forgot, we lie in country graveyards high on lonely hills.</p>
<p class="poem-line">We are unwept save by such tears as sheds,</p>
<p class="poem-line">The weeping sky.</p>
<p class="poem-linet">Above old huddled graves in city streets, sometimes a passer finds,</p>
<p class="poem-line">The time to pause and sigh remembering.</p>
<p class="poem-line">But none pass by us here,</p>
<p class="poem-line">Above us sigh only the winds.</p>
<p class="poem-linet">The hands that laid us here long, long ago are dust.</p>
<p class="poem-line">The impassioned tears shed then for us are dried.</p>
<p class="poem-line">The faltering feet that followed us in grief have now lain still,</p>
<p class="poem-line">Unnumbered years.</p>
<p class="poem-linet">And, strange hands now till the fields we cleared.</p>
<p class="poem-line">Strange voices ring beneath the roofs we raised.</p>
<p class="poem-line">Beneath the trees we planted, strange young lovers make their vows,</p>
<p class="poem-line">Each passing spring.</p>
<p class="poem-linet">The alien plow that draws so near…so near.</p>
<p class="poem-line">Disturbs our rest.</p>
<p class="poem-line">Here in our sunken and neglected graves we stir.</p>
<p class="poem-line">Who will protest?</p>
<p class="poem-linet">We are unclamoring.</p>
<p class="poem-line">We only ask that we may lie,</p>
<p class="poem-line">Safe from the plow that threatens our old graves,</p>
<p class="poem-line">Covered by vines, mourned by the passing winds,</p>
<p class="poem-line">Wept by the sky.</p>
<p class="poem-author">Anonymous</p>
<p class="poem-author0">Possibly written by Ossie Glenn</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_FM01.vue?ca59aaae